<!-- <h5>Question data:</h5> -->
<!-- <pre>{{question.key|json}}</pre> -->
<div
  [formGroup]="form"
  *ngIf="question && showQuestion"
  [hidden]="question.hidden"
  [ngClass]="{ 'hasError': fieldErrors, 'inline-toggle': question.layout === 'switch', 'inline-question': question.settings && question.settings.inline }"
  [class]="'padding-top-medium form-typography raptor-question-key-' + question.key + ' ' + classes"
>
  <div *ngIf="question.info && question.info.settings && question.info.settings.align === 'top'" class="margin-bottom-xmedium">
    <open-raptor-info [info]="question.info" [form]="form"></open-raptor-info>
  </div>

  <div class="raptor-question-conatiner">
    <div class="raptor-question-label-container">
      <div class="flex flex-content-center">
        <label *ngIf="question.prompt" [attr.for]="question.key" class="raptor-question-label">
          <span [ngClass]="{ 'dd-privacy-mask': question.type === 'medical_screening' }">{{ question.prompt }}</span>
        </label>
        <open-tooltip *ngIf="question.help && (!question.help.type || question.help.type === 'tooltip')" [tooltipContent]="question.help.content"></open-tooltip>
      </div>
      <p
        *ngIf="question.subtext"
        class="margin-bottom-xxsmall"
        [innerHTML]="question.subtext"
        [ngClass]="{
          'text-left': !question.settings || !question.settings.align || question.settings.align === 'left',
          'text-center': question.settings.align === 'center',
          'text-right': question.settings.align === 'right',
          'dd-privacy-mask': question.type === 'medical_screening'
        }"
      ></p>
    </div>

    <div [ngSwitch]="question.type" class="raptor-question-field" [ngClass]="{'raptor-question-change-valid': validWithChange === true, 'raptor-question-change-invalid': validWithChange === false }">

      <!-- STRING FIELDS -->
      <div *ngSwitchCase="'string'" class="raptor-question-type-string">

        <div *ngIf="question.layout; then stringLayout else stringNoLayout"></div>
        <ng-template #stringLayout>
          <div *ngIf="question.layout" [ngSwitch]="question.layout">
            <mat-form-field *ngSwitchCase="'mobile_input'" appearance="outline" [class]="(question.settings && question.settings.size)">
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position !== 'after'" matPrefix>{{ question.settings.icon.name }}</mat-icon>
              <input matInput [formControlName]="question.key" [id]="question.key" type="tel" [placeholder]="(question.settings && question.settings.placeholder)">
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position === 'after'" matSuffix>{{ question.settings.icon.name }}</mat-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
            </mat-form-field>

            <mat-form-field *ngSwitchCase="'email_input'" appearance="outline" [class]="(question.settings && question.settings.size)">
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position !== 'after'" matPrefix>{{ question.settings.icon.name }}</mat-icon>
              <input matInput [formControlName]="question.key" [id]="question.key" type="email" [placeholder]="(question.settings && question.settings.placeholder)" [raptorTextTransform]="(question.settings && question.settings.text_transform)">
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position === 'after'" matSuffix>{{ question.settings.icon.name }}</mat-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
            </mat-form-field>

            <mat-form-field *ngSwitchCase="'text_long'" appearance="outline" [class]="(question.settings && question.settings.size)">
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position !== 'after'" matPrefix>{{ question.settings.icon.name }}</mat-icon>
              <textarea matInput [formControlName]="question.key" [id]="question.key" [placeholder]="(question.settings && question.settings.placeholder)" [rows]="(question.settings && question.settings.rows || 2)" [maxlength]="(question.settings && question.settings.maxlength)"></textarea>
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position === 'after'" matSuffix>{{ question.settings.icon.name }}</mat-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
            </mat-form-field>

            <!-- this default value should not ever render but is here in case there is a layout this template does not understand -->
            <mat-form-field *ngSwitchDefault appearance="outline" [class]="(question.settings && question.settings.size)">
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position !== 'after'" matPrefix>{{ question.settings.icon.name }}</mat-icon>
              <input matInput [formControlName]="question.key" [id]="question.key" type="text" [placeholder]="(question.settings && question.settings.placeholder)" [raptorTextTransform]="(question.settings && question.settings.text_transform)">
              <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position === 'after'" matSuffix>{{ question.settings.icon.name }}</mat-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
              <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
            </mat-form-field>
          </div>
        </ng-template>

        <ng-template #stringNoLayout>
          <mat-form-field appearance="outline" [class]="(question.settings && question.settings.size)">
            <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
            <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
            <input matInput [formControlName]="question.key" [id]="question.key" type="text" [placeholder]="(question.settings && question.settings.placeholder)" [raptorTextTransform]="(question.settings && question.settings.text_transform)">
            <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
            <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
          </mat-form-field>
        </ng-template>

      </div>

      <!-- NUMBER FIELDS -->
      <div *ngSwitchCase="'number'" [ngSwitch]="question.layout" class="raptor-question-type-number">

        <!-- This needs to implement the open range slider component-->
        <!-- <div *ngSwitchCase="'slider'" class="raptor-question-layout-slider">
          <mat-slider
            [formControlName]="question.key"
            [id]="question.key"
            [min]="question.settings.range.min"
            [max]="question.settings.range.max"
            [step]="question.settings.range.step"
            tickInterval="1"
            [displayWith]="formatSliderLabel"
            thumbLabel="false"

          ></mat-slider>
          <sub *ngIf="fieldValue">Value: {{ fieldValue }}</sub>
        </div> -->

        <div *ngSwitchCase="'increment'" class="raptor-question-layout-increment" [class]="(question.settings && question.settings.size)">
          <open-raptor-increment [question]="question" [form]="form"></open-raptor-increment>
        </div>

        <mat-form-field  *ngSwitchDefault appearance="outline" [class]="(question.settings && question.settings.size)">
          <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.valid" matPrefix></open-svg-icon>
          <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'before'" [name]="question.settings.validateOnChange.error" matPrefix></open-svg-icon>
          <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position !== 'after'" matPrefix>{{ question.settings.icon.name }}</mat-icon>
          <input matInput [formControlName]="question.key" [id]="question.key" type="text" inputmode="decimal" [placeholder]="(question.settings && question.settings.placeholder)">
          <mat-icon *ngIf="question.settings && question.settings.icon && question.settings.icon.position === 'after'" matSuffix>{{ question.settings.icon.name }}</mat-icon>
          <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.valid" matSuffix></open-svg-icon>
          <open-svg-icon class="validate-on-change-icon" *ngIf="validWithChange === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'" [name]="question.settings.validateOnChange.error" matSuffix></open-svg-icon>
        </mat-form-field>
      </div>

      <!-- CURRENCY FIELDS -->
      <div *ngSwitchCase="'currency'" class="raptor-question-type-currency">
        <mat-form-field appearance="outline" [class]="(question.settings && question.settings.size)">
          <input matInput [formControlName]="question.key" [id]="question.key" type="text" [placeholder]="(question.settings && question.settings.placeholder)">
        </mat-form-field>
      </div>

      <!-- DATE FIELDS -->
      <div *ngSwitchCase="'date'" [ngSwitch]="question.layout" class="raptor-question-type-date">

        <div *ngSwitchCase="'date_input_3_boxes'">
          <div [formGroupName]="question.key" class="raptor-question-layout-date_input_3_boxes" [class]="(question.settings && question.settings.size)">
            <div>
              <mat-form-field appearance="outline">
                <input matInput formControlName="day" [id]="question.key + '_day'" type="number" inputmode="numeric" placeholder="DD" maxlength="2" min="1" raptorAutotab>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <input matInput formControlName="month" [id]="question.key + '_month'" type="number" inputmode="numeric" placeholder="MM" maxlength="2" min="1" raptorAutotab>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <input matInput formControlName="year" [id]="question.key + '_year'" type="number" inputmode="numeric" placeholder="YYYY" maxlength="4">
              </mat-form-field>
            </div>
          </div>
          <div class="date_input_3_boxes_errors">
            <mat-error *ngIf="isGroupItemDirty('day') && hasError(form.controls[question.key], 'day')">Please enter a valid day</mat-error>
            <mat-error *ngIf="isGroupItemDirty('month') && hasError(form.controls[question.key], 'month')">Please enter a valid month</mat-error>
            <mat-error *ngIf="isGroupItemDirty('year') && hasError(form.controls[question.key], 'year')">Please enter a valid year</mat-error>
          </div>
        </div>

        <div *ngSwitchCase="'date_select_month_year'">
          <div [formGroupName]="question.key" class="raptor-question-layout-date_select_month_year" [class]="(question.settings && question.settings.size)">
            <input type="hidden" formControlName="day" [id]="question.key + '_day'" />
            <mat-form-field appearance="outline" *ngIf="question.settings.month.choices.length">
              <select matNativeControl formControlName="month" [id]="question.key + '_month'">
                <option value="" class="placeholder" disabled selected hidden>Month</option>
                <option *ngFor="let option of question.settings.month.choices" [ngValue]="option.value">{{ option.label }}</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <select matNativeControl formControlName="year" [id]="question.key + '_year'">
                <option value="" class="placeholder" disabled selected hidden>Year</option>
                <option *ngFor="let option of question.settings.year.choices" [ngValue]="option.value">{{ option.label }}</option>
              </select>
            </mat-form-field>
          </div>
          <div class="date_select_month_year_errors">
            <mat-error *ngIf="isGroupItemDirty('month') && hasError(form.controls[question.key], 'month')" [ngClass]="'test'">Please enter a valid month</mat-error>
            <mat-error *ngIf="isGroupItemDirty('year') && hasError(form.controls[question.key], 'year')">Please enter a valid year</mat-error>
          </div>
        </div>

        <div *ngSwitchCase="'range'">
          <mat-form-field appearance="outline" [class]="(question.settings && question.settings.size)">
            <mat-date-range-input [formGroupName]="question.key" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
              <input matInput matStartDate [formControlName]="'start'" [id]="question.key + '_start'" placeholder="Start date" (focus)="picker.open()" (click)="picker.open()" (keydown)="blockUserInput($event)">
              <input matInput matEndDate [formControlName]="'end'" [id]="question.key + '_end'" placeholder="End date" (focus)="picker.open()" (click)="picker.open()" (keydown)="blockUserInput($event)">
            </mat-date-range-input>
            
            <mat-datepicker-toggle [for]="picker" matPrefix>
              <mat-icon matDatepickerToggleIcon class="calendar_today_outline material-icons-outlined"></mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>            
          </mat-form-field>
        </div>

        <div *ngSwitchDefault>
          <mat-form-field appearance="outline" [class]="(question.settings && question.settings.size)">
            <input matInput [matDatepicker]="date" [formControlName]="question.key" [id]="question.key" [min]="minDate" [max]="maxDate" (focus)="date.open()" placeholder="dd/mm/yyyy">
            <mat-datepicker-toggle [for]="date" matPrefix>
              <mat-icon matDatepickerToggleIcon class="calendar_today_outline material-icons-outlined"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #date yPosition="below"></mat-datepicker>
          </mat-form-field>
        </div>

      </div>

      <!-- CHOICE FIELDS -->
      <div *ngSwitchCase="'choice'" [ngSwitch]="question.layout" class="raptor-question-type-choice">

        <open-button-toggle *ngSwitchCase="'radio_button_group'" [question]="question" [form]="form"></open-button-toggle>

        <div *ngSwitchCase="'switch'" class="raptor-question-layout-inline-toggle">
          <mat-slide-toggle [formControlName]="question.key"></mat-slide-toggle>
        </div>

        <div *ngSwitchCase="'radio_tile'" class="raptor-question-layout-tile">
          <open-tile-radio [question]="question" [form]="form" tooltip="true"></open-tile-radio>
        </div>

        <div *ngSwitchCase="'radio_group'" class="raptor-question-layout-radio">
          <mat-radio-group [formControlName]="question.key" aria-label="Select an option">
            <ul class="control-list">
              <li *ngFor="let option of question.settings.choices">
                <mat-radio-button [value]="option.value" (change)="playAnimation(option)">
                  <div class="flex">
                    <span class="flex-grow">{{ option.label }}</span>
                  </div>
                </mat-radio-button>
                <ng-container *ngIf="option.help && (!option.help.type || option.help.type === 'tooltip')">
                  <open-tooltip [tooltipContent]="option.help.content"></open-tooltip>
                </ng-container>
              </li>
            </ul>
          </mat-radio-group>
        </div>

        <div *ngSwitchCase="'increment'" class="raptor-question-layout-increment" [class]="(question.settings && question.settings.size)">
          <open-raptor-increment [question]="question" [form]="form"></open-raptor-increment>
        </div>

        <mat-form-field *ngSwitchDefault appearance="outline" [class]="(question.settings && question.settings.size)">
          <select matNativeControl [formControlName]="question.key">
            <option value="null" class="placeholder" disabled selected hidden>{{ (question.settings && question.settings.placeholder) ? question.settings.placeholder : 'Please choose' }}</option>
            <option *ngFor="let option of question.settings.choices" [ngValue]="option.value">{{ option.label }}</option>
          </select>
        </mat-form-field>

      </div>

      <!-- MULTIPLE CHOICE FIELDS -->
      <div *ngSwitchCase="'multiple_choice'" [ngSwitch]="question.layout" class="raptor-question-type-mulitpleChoice">

        <div *ngSwitchCase="'checkbox_tile'" class="raptor-question-layout-tile" [class]="'raptor-tile-length-' + question.settings.choices.length">
          <open-tile-checkbox [question]="question" [form]="form"></open-tile-checkbox>
        </div>

        <div *ngSwitchCase="'checkbox_tile_toggle'" class="raptor-question-layout-tile-toggle">
          <open-tile-toggle [question]="question" [form]="form" tooltip="true"></open-tile-toggle>
        </div>

        <div *ngSwitchCase="'checkbox_toggle'" [formGroupName]="question.key">
          <div *ngFor="let option of question.settings.choices" class="flex margin-xsmall">
            <label class="flex-grow">{{ option.label }}</label>
            <mat-slide-toggle [formControlName]="option.value"></mat-slide-toggle>
          </div>
        </div>

        <ul *ngSwitchDefault [formGroupName]="question.key" class="control-list">
          <li *ngFor="let option of question.settings.choices">
            <mat-checkbox [formControlName]="option.value" [value]="option.value"></mat-checkbox>
            <div>
              <b *ngIf="option.label" class="label">{{ option.label }}</b>
              <ng-container *ngIf="option.help && (!option.help.type || option.help.type === 'tooltip')">
                <open-tooltip [tooltipContent]="option.help.content"></open-tooltip>
              </ng-container>
              <p *ngIf="option.text" class="text-small">{{ option.text }}</p>
            </div>
          </li>
        </ul>

      </div>

      <!-- EXTRAS FIELDS -->
      <div *ngSwitchCase="'extras'" [ngSwitch]="question.layout" class="raptor-question-type-mulitpleChoice">
        <div *ngSwitchCase="'checkbox_tile_toggle'" class="raptor-question-layout-tile-toggle">
          <open-tile-toggle [question]="question" [form]="form" tooltip="true"></open-tile-toggle>
        </div>
        <div *ngSwitchDefault class="raptor-question-layout-tile-toggle">
          <open-tile-toggle [question]="question" [form]="form" tooltip="true"></open-tile-toggle>
        </div>
      </div>

      <!-- CONFIRMATION FIELDS -->
      <div *ngSwitchCase="'confirm'" [ngSwitch]="question.layout" class="raptor-question-type-confirm">
        <div class="open-tile-checkbox" [ngClass]="{ 'tile-align-left': question.settings.align === 'left', 'tile-align-right': question.settings.align === 'right' }">
          <div class="checkbox-wrapper">
            <mat-checkbox [formControlName]="question.key" [class]="question.settings.size">
              <div class="tile-label-content">
                <b class="label" *ngIf="question.settings.label">{{ question.settings.label }}</b>
                <p class="input-small" *ngIf="question.settings.text">{{ question.settings.text }}</p>
              </div>
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!-- REPEATER FIELDS -->
      <div *ngSwitchCase="'repeater'" [ngSwitch]="question.layout" class="raptor-question-type-repeater">
        <div *ngSwitchCase="'multiple'">
          <open-raptor-repeater-multiple-question [question]="question" [form]="form" [submitted]="submitted"></open-raptor-repeater-multiple-question>
        </div>
        <div *ngSwitchDefault>
          <open-raptor-repeater-question [question]="question" [form]="form"></open-raptor-repeater-question>
        </div>
      </div>

      <!-- AUTOCOMPLETE FIELDS -->
      <div *ngSwitchCase="'autocomplete'" class="raptor-question-type-autocomplete">
        <open-raptor-autocomplete [question]="question" [form]="form"></open-raptor-autocomplete>
      </div>

      <!-- FIELDS MULTIPLE FIELDS -->
      <div *ngSwitchCase="'autocomplete_multiple'" class="raptor-question-type-autocomplete-multiple">
        <open-raptor-autocomplete-multiple [question]="question" [form]="form"></open-raptor-autocomplete-multiple>
      </div>

      <!-- VEHICLE FIELDS -->
      <div *ngSwitchCase="'vehicle'" class="raptor-question-type-vehicle">
        <open-raptor-vehicle-select [question]="question" [form]="form"></open-raptor-vehicle-select>
      </div>

      <!-- MEMBER/EMPLOYEE VALIDATION FIELDS -->
      <div *ngSwitchCase="'validation'" class="raptor-question-type-validation">
        <open-raptor-validation [question]="question" [form]="form"></open-raptor-validation>
      </div>

      <!-- PRE-EX MEDICAL FIELDS -->
      <div *ngSwitchCase="'medical_screening'" class="raptor-question-type-medical">
        <open-raptor-medical [question]="question" [form]="form"></open-raptor-medical>
      </div>

      <div *ngSwitchCase="'mobile'" class="raptor-question-type-mobile">
        <open-raptor-mobile [question]="question" [form]="form"></open-raptor-mobile>
      </div>
    </div>
  </div>

  <!-- <h5>Field errors:</h5> -->
  <open-raptor-question-error [question]="question" [form]="form" [submitted]="submitted"></open-raptor-question-error>

  <!-- Question disclaimer -->
  <p *ngIf="question.disclaimer && question.disclaimer.content" class="raptor-question-disclaimer text-small margin-top-xxsmall" [innerHTML]="question.disclaimer.content"></p>

  <div class="margin-top-small" *ngIf="question.info && (!question.info.settings || question.info.settings.align !== 'top')">
    <open-raptor-info [info]="question.info" [form]="form"></open-raptor-info>
  </div>
</div>

